import Component from '../core/Component'
import MarketFormFileItem from './MarketFormFileItem'
import Dropzone from 'dropzone'
Dropzone.autoDiscover = false

import Sortable from 'sortablejs'

export default class MarketFormAd extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            gallery: null,
            fileButton: null,
            template: null
        }
    }

    prepare() {
        this.dropzone = new Dropzone(this.element, {
            autoProcessQueue: false,
            uploadMultiple: true,
            parallelUploads: 10,
            maxFiles: 100,
            addRemoveLinks: true,
            previewsContainer: null,
            thumbnailWidth: 118,
            thumbnailHeight: 80,
            thumbnailMethod: 'crop',
            clickable: this.ref.fileButton,
            addedfile: ::this.handleFileAdded,
            // removedfile: ::this.handleFileRemoved,
            thumbnail: ::this.handleFileThumbnail,
            success: ::this.handleSuccess
        })

        this.template = this.ref.template.innerText

        this.element.addEventListener('submit', ::this.handleSubmit)
        this.element.addEventListener('reset', ::this.handleReset)

        this.sortable = new Sortable.create(this.ref.gallery, {
            draggable: '.market-Form-galleryItem',
            ghostClass: 'is-ghost',
            chosenClass: 'is-chosen',
            dragClass: 'is-dragging',
            animation: 150
        })
    }

    handleSubmit(event) {
        if (this.dropzone.getQueuedFiles().length) {
            event.preventDefault()
            this.dropzone.processQueue()
        }
    }

    handleReset() {
        this.dropzone.removeAllFiles()
    }

    handleFileAdded() {
    }

    handleFileThumbnail(file, dataUrl) {
        const buffer = document.createElement('div')
        buffer.innerHTML = this.template

        const item = buffer.querySelector('[data-component]')
        item.querySelector('img').src = dataUrl

        this.ref.gallery.appendChild(item)

        new MarketFormFileItem(item, {
            file: file,
            onRemove: ::this.handleRemove
        }).prepare()
    }

    handleRemove(file) {
        this.dropzone.removeFile(file)
    }

    handleSuccess(file, response) {
        if (response && response.redirect) {
            window.location = response.redirect
        }
    }
}